import React from "react";
import Grid from "@material-ui/core/Grid";
import HeaderAll from "../../../HeaderAll";

function HeaderJard({ found, typePrint ,infoData}) {
  const styf = { fontWeight: "1200" };
  const styfC = { fontWeight: "500" };

  return (
    <Grid item container
      style={{ fontWeight: "bold", fontFamily: "Amiri-Regular", }}>
      <HeaderAll Report={true} found={found} />
      <Grid item container style={{ paddingTop: "0.5rem", paddingBottom: "0.5rem" }}>
        <Grid item xs={12} style={{
          fontFamily: "Amiri-Regular", border: "solid 2px", paddingTop: "0.5rem", paddingBottom: "0.5rem",
          borderRadius: "5px", textAlign: "center",
        }}
        >
          <div style={styf}>
            {infoData.title}
          </div>
        </Grid>
      </Grid>

      <Grid item container
        style={{
          fontFamily: "Amiri-Regular", padding: "0.3rem", border: "solid 2px",
          borderRadius: "5px", direction: "rtl",
        }}>
        {typePrint == 1 ?
          (
            <Grid item xs={12} container>
              <Grid item xs={6} style={{ textAlign: "right" }}>
                {'المخزن'} /{" "} {infoData.auto?.safe}
              </Grid>
              <Grid item xs={3}>
                <div style={styfC}>  {"المستخدم"}  {"   /"} {infoData.auto.user}</div>
              </Grid>
              <Grid item xs={3}>
                <div style={styfC}> {"تاريخ الطباعة"} {"    /"} {infoData.nDate}</div>
              </Grid>
            </Grid>
          ) : (
            <Grid item xs={12} container>
              <Grid item xs={2} style={{ textAlign: "right" }}>
                {"الفرع"}/{" "} {infoData.branch}
              </Grid>
              <Grid item xs={3} style={{ textAlign: "right" }}>
                {"المخزن"} /{" "} {infoData.safe}
              </Grid>
              <Grid item xs={3} style={{ textAlign: "right" }}>
                {"مجموعة الصنف"} /{" "}   {infoData.group}
              </Grid>
              <Grid item xs={3} style={{ textAlign: "right" }}>
                <div style={styfC}> {"تاريخ الطباعة"} {"    /"} {infoData.nDate}</div>
              </Grid>
            </Grid>
          )}
      </Grid>
    </Grid>
  );
}
export default HeaderJard;
